
/* START_TEMPLATE */
define('hbs!app/views/templates/footer',['hbs','Handlebars'], function( hbs, Handlebars ){ 
var t = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"navbar navbar-fixed-bottom\">\r\n    <div class=\"navbar-inner\">\r\n        <div class=\"container\">\r\n            <div class=\"footer-copyright\">\r\n                <p class=\"navbar-text\">"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.Localization : depth0)) != null ? stack1.general : stack1)) != null ? stack1.copyright : stack1), depth0))
    + "</p>\r\n            </div>\r\n            <div class=\"footer-terms\">\r\n                <p class=\"navbar-text\"><a href=\""
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.Localization : depth0)) != null ? stack1.general : stack1)) != null ? stack1.termsLink : stack1), depth0))
    + "\" target=\"_blank\">"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.Localization : depth0)) != null ? stack1.general : stack1)) != null ? stack1.termsText : stack1), depth0))
    + "</a></p>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n";
},"useData":true});
Handlebars.registerPartial('app/views/templates/footer', t);
return t;
});
/* END_TEMPLATE */
;
